import Helmet from "react-helmet"
import React from "react"
import Disclosure from "@tightrope/disclaimers";
import ExtendedHomepage from "src/components/extendedHomepage"
import HomepageLayout from "src/layouts/homepage"
import RawFooter from "@tightrope/footerlinks/rawfooter.js"
import {isIeEdge,isChrome,isFirefox, isSafari} from "@tightrope/lpscripts/browserdetect"


const homepageData = import("./homepage.json");
const footer = <RawFooter></RawFooter>

export default function HomePage() {
  let disclosure = null;

  if(isIeEdge()){
      disclosure = <Disclosure language='en-clear-edge'></Disclosure>;
  }
 if(isFirefox()){
      disclosure = <Disclosure language='en-firefox'></Disclosure>;

  }
 if(isSafari()) {
     disclosure = <Disclosure language='en-safari'></Disclosure>;
 }
  if(isChrome()){
        disclosure = <Disclosure language='en-chrome'></Disclosure>;
    }
  return(
    <HomepageLayout>
      <Helmet>
      <style type="text/css">{`
#disclaimers-module--disclaimers p {
  text-align: center;
  color: #fff;
  font-size: 13px;
  width: 466px;
  line-height: 150%;
  margin: 0 auto 12px;
}

#disclaimers-module--disclaimers p a {
  color: #12d6df;
}

.extendedhomepage-module--middle #disclaimers-module--disclaimers p, .extendedhomepage-module--bottom #disclaimers-module--disclaimers p {
  color: #222;
}

.extendedhomepage-module--middle #disclaimers-module--disclaimers p a, .extendedhomepage-module--bottom #disclaimers-module--disclaimers p a {
  color: #01CED8;
}

.extendedhomepage-module--bannerLeft #disclaimers-module--disclaimers p {
  width: 513px;
}


        footer {
          position: relative;
          width: 100%;
          bottom: 2px;
          padding: 0;
          margin:0;
          z-index: 1;
        }
        footer ul {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap:wrap;
          color: #666;
          font-size: 12px;
          padding: 10px 0;
          list-style:none;
        }
        footer ul li {
          margin: 0;
        }
        footer ul li a {
          text-decoration: none;
          color: #666;
        }
        footer ul li:after {
          content: '|';
          padding: 0 4px;
        }
        footer ul li:last-child:after {
          content: none;
          padding: 0;
        }

        @media screen and (max-width: 576px) {

        .extendedhomepage-module--bannerLeft #disclaimers-module--disclaimers p, .extendedhomepage-module--middle #disclaimers-module--disclaimers p, .extendedhomepage-module--bottom #disclaimers-module--disclaimers p {
          width: 90%;
        }
      }

                

        `}</style>
      <title>Flair Wallpapers</title></Helmet>
      <ExtendedHomepage data={homepageData}>
      <div className="disc">{disclosure}</div>
      </ExtendedHomepage>
      <RawFooter></RawFooter>
    </HomepageLayout>
  )
}
